import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=2cb9a188&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=2cb9a188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9a188",
  null
  
)

export default component.exports